export { between } from './between/between';
export { clamp }   from './clamp/clamp';
export { sign }    from './sign/sign';

export const { min, max, floor, ceil, abs, round } = Math;
